import { render, staticRenderFns } from "./NotificationAppointmentReminder.vue?vue&type=template&id=f5c7ea38&scoped=true&"
import script from "./NotificationAppointmentReminder.vue?vue&type=script&lang=ts&"
export * from "./NotificationAppointmentReminder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c7ea38",
  null
  
)

export default component.exports